import { Injectable, inject } from '@angular/core';
import { HttpRequest, HttpHandler, HttpInterceptor, HttpEvent } from '@angular/common/http';
import { Observable } from 'rxjs';
import { StorageService } from '../services/storage.service';
/**
 * Bearer interceptor
 * @injectable
 */
@Injectable({ providedIn: 'root' })
/**
 * Bearer interceptor
 * @class BearerInterceptor
 * @implements {HttpInterceptor}
 */
export class BearerInterceptorService implements HttpInterceptor {
  /**
   * inject storage service
   * @type {StorageService}
   */
  private storageService = inject(StorageService);


  /**
   * Adds Bearer token to the headers of the request if it exists in the session storage
   * @param {HttpRequest<any>} req - The request
   * @param {HttpHandler} next - The http handler
   * @returns The observable of the http event
   */
  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    const token = this.storageService.getToken();

    const userRegion = this.storageService.getUserRegion();
    /**
     * if user region exist update the request url with user region  
     */
    if (userRegion) {
      if (!req.url.includes('./assets/i18n')) {
        const updatedUrl = req.url.replace('api', `${userRegion}.api`);
        req = req.clone({
          url: updatedUrl
        });
      }
    }
    if (token) {
      req = req.clone({
        setHeaders: {
          Authorization: `Bearer ${token}`
        }
      });
      return next.handle(req);
    } else {
      return next.handle(req);
    }

  }
}

